import "./authForm.scss";
import Icon from "../icon-component/Icon";
import Text from "../text-component/Text";
import icons from "../../helpers/iconMenu";
import Button from "../button-component/Button";
import React, {useState} from "react";
import InputField from "../input-component/InputField";
import {getStaticText} from "../../lables/lablesService";
import Spinner from "../spinner-component/Spinner";

/**
 * Auth component
 *
 * @params  props object
 * @returns JSX
 */
const AuthForm = React.memo(({
                                 Login,
                                 user_name,
                                 errorMessage,
                                 user_password,
                                 handleChangeName,
                                 handleChangePassword,
                             }) => {
    const [changeClass, setChangeClass] = useState(true);
    const [passwordShow, setPasswordShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    /**
     * Password toggle handler change class icon
     *                         change type input
     * @params event
     */
    const togglePassword = e => {
        e.stopPropagation();
        setPasswordShow(!passwordShow);
        setChangeClass(!changeClass)
    };

    /**
     * Submit the form and check the correct login method
     *
     * @params event
     */
    const submitHandler = async e => {
        e.preventDefault();

        setIsLoading(true);

        try {
            await Login();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100dvh",
                    overflow: 'hidden'
                }}
            >
                <Spinner/>
            </div>
        );
    }

    return (
        <div className="Auth-form-container">

            <form className="Auth-form" onSubmit={submitHandler}>
                <div className="Auth-form-content">
                    <Text
                        content={getStaticText('sign_in_title')}
                        text_style={"Auth-form-title pt-2"}
                    />

                    {errorMessage && <Text
                        content={errorMessage}
                        text_style={"alert alert-danger p-0 pt-1 pb-1 text-center h6"}
                    />}

                    <InputField
                        type={"text"}
                        value={user_name}
                        onChange={handleChangeName}
                        label={getStaticText('login_label')}
                        input_class={"form-control mt-1 shadow-none"}
                        placeholder={getStaticText('login_placeholder')}
                    />
                    {/* Message about an empty input field */}
                    <InputField
                        value={user_password}
                        onChange={handleChangePassword}
                        label={getStaticText('pass_label')}
                        type={passwordShow ? "text" : "password"}
                        input_class={"form-control mt-1 shadow-none"}
                        placeholder={getStaticText('pass_placeholder')}
                    >
                        <Icon
                            onClick={togglePassword}
                            style={{position: 'relative', left: '160px', top: "38px"}}
                            icon_style={changeClass ? icons.auth_form_icon_eye_close : icons.auth_form_icon_eye_open}
                        />
                    </InputField>

                    <div className="d-grid gap-2 mt-3 mb-2">
                        <Button
                            type={"submit"}
                            bgcolor={"primary"}
                            btn_disabled={!user_password || !user_name || isLoading}
                            btn_styles={"btn-active shadow-none"}
                            label={ getStaticText('submit_btn')}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
})

export default AuthForm;